import { Button, Modal, ModalBody, ModalContent, ModalHeader } from "@heroui/react";
import type { MutationStatus } from "@tanstack/react-query";
import type { BridgeFormData } from "../../mutations/bridge";
import { BridgeCard } from "./BridgeCard";
import { TransactionTypeChip } from "./TransactionTypeChip";

export function BridgeReviewModal({
  isOpen,
  onClose,
  bridgeFormData,
  onBridge,
  status,
}: {
  isOpen: boolean;
  onClose: () => void;
  bridgeFormData: BridgeFormData | null;
  onBridge: () => void;
  status: MutationStatus;
}) {
  if (!bridgeFormData) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalHeader>Confirm Bridge</ModalHeader>

        <ModalBody>
          <BridgeCard
            bridgeType={bridgeFormData.bridgeType}
            displayAmount={Number(bridgeFormData.transferAmount)}
            tokenSymbol={bridgeFormData.tokenSymbol}
          />

          <div className="w-full space-y-3">
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Transaction type</div>
              <TransactionTypeChip type="public" />
            </div>
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Est. Time</div>
              <div className="font-semibold">~15 min</div>
            </div>
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Gas fees</div>
              <div className="font-semibold">0.00005 ETH</div>
            </div>
          </div>

          {status === "pending" ? (
            <Button
              fullWidth
              radius="full"
              size="lg"
              className="font-semibold text-large h-16 bg-[#3F6784] text-white"
              isLoading
            >
              Confirm in the wallet...
            </Button>
          ) : (
            <Button
              fullWidth
              radius="full"
              size="lg"
              color="primary"
              className="font-semibold text-large h-16"
              onPress={onBridge}
            >
              Bridge
            </Button>
          )}

          <p className="text-[#ADC0D0]">
            Once the Bridge transaction is completed, you will need to claim your tokens on the Aztec Network.
          </p>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
